import {h, Component} from 'preact';
import { OnboardingService, CreatePasswordInput } from '@webapp/preact-shared';
import authContainer from '../tags/auth-container';
import CloseButtonWithCircle from '../tags/close-button-with-circle';

export class ResetTempPassword extends Component {
    constructor() {
        super();
        this.state = {
            isGoodPassword: false,
            passwordError: '',
            createPasswordLoading: false,
            onVerifyAgain: false
        }
    }
    componentDidMount() {
        document.title = 'Reset temp password | workplace_';
        this.props.hideFooter();
    }

    goToLoginPage = () => {
        this.props.goToPage('/');
    };

    goToUserApp = () => {
        OnboardingService.setOnboardingStatus('Completed')
            .then(() => {
                this.props.goToPage('/session-status');
            });
    };

    setPasswordValidation = isGoodPassword => {
        this.setState({ isGoodPassword });
    };

    setPassword = password => {
        this.setState({ password });
    };

    createPassword = () => {
        if (this.state.createPasswordLoading) {
            console.log('Loading...');
        } else {
            this.setState({ createPasswordLoading: true, passwordError: '' });
            OnboardingService.setUserPassword(this.state.password)
                .then(() => {
                    this.setState({ createPasswordLoading: false, passwordError: '' });
                    this.goToUserApp();
                }, error => {
                    const errorStatus = error.response.status;
                    this.setState({ createPasswordLoading: false });
                    if (errorStatus === 403) {
                        if (error.response.data && error.response.data.message) {
                            console.error('setUserPassword (403) error: ' + error.response.data.message);
                        } else {
                            console.error('setUserPassword (403) error');
                        }
                        this.setState({ passwordError: 'Your password was already created. Please refresh the page to continue.' });
                    } else {
                        if (error.response.data && error.response.data.message) {
                            console.error('setUserPassword error: ' + error.response.data.message);
                            this.setState({ passwordError: 'An error occurred, please try again later.' });
                        } else {
                            this.setState({ passwordError: 'You can\'t set passwords you\'ve used before or that contain personal information.' });
                        }
                    }
                });
        }
    };

    render({}, {isGoodPassword, passwordError, createPasswordLoading, onVerifyAgain}) {
        return(
            <section className='auth-modal-container reset-temp-password'>
                <div className='form'>
                    <h2>Change your Workplace password <CloseButtonWithCircle action={this.goToLoginPage}/></h2>
                    <div className='create-new-password clearfix'>
                        <CreatePasswordInput setPassword={this.setPassword}
                                             passwordError={passwordError}
                                             action={this.createPassword}
                                             setPasswordValidation={this.setPasswordValidation}
                                             minLength={9}
                        />
                        <div className='bottom-buttons clearfix'>
                            <a className={`button-prime button pull-right ${isGoodPassword ? '' : 'disabled'} ${createPasswordLoading ? 'loading' : ''}`}
                               onClick={this.createPassword}>
                                Create password
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default authContainer(ResetTempPassword);




// WEBPACK FOOTER //
// ./src/scripts/views/reset-temp-password/reset-temp-password.js